import React from "react"
import tw from "twin.macro"

const CloseButton = ({ onClick }) => (
  <div
    onClick={onClick}
    css={[
      tw`flex items-center justify-center w-5 h-5 rounded-full bg-gray-400 hover:bg-gray-400 cursor-pointer`,
    ]}
  >
    <span css={[tw`text-gray-900 text-sm leading-none`]}>&times;</span>
  </div>
)
const capitalizeFirstLetter = (input: string | string[]): string => {
  if (Array.isArray(input)) {
    return input.map(item => capitalizeFirstLetter(item)).join(" ")
  }
  if (typeof input !== "string" || input.length === 0) {
    return input
  }
  return input.charAt(0).toUpperCase() + input.slice(1)
}

const FilterTag = ({ label, value, filterKey, onRemove }) => {
  if (!label || !value) return null

  return (
    <div
      css={[
        tw`inline-flex text-sm flex-col py-2 px-6 bg-gray-100 rounded-full`,
      ]}
    >
      <div css={[tw`flex items-center leading-[0]`]}>
        <CloseButton onClick={() => onRemove(filterKey)} />
        <span css={[tw`ml-2 text-gray-700 font-light`]}>
          {capitalizeFirstLetter(label)}
        </span>
      </div>
    </div>
  )
}

const FilterTags = ({ filters = {}, onRemove }) => {
  if (!filters || typeof filters !== "object") {
    return null
  }

  const formatFilterValue = (
    key: string,
    value: { toString: () => any; split: (arg0: string) => [any, any] },
  ) => {
    if (!value) return ""
    switch (key) {
      case "zip":
        return value.toString()
      case "distance":
        return `${value} mi`
      case "price":
        const [min, max] = value.split("-")
        return `$${min}K-$${max}K`
      case "available":
        return value
      case "dealer":
        return value
      default:
        return value.toString()
    }
  }

  const getFilterLabel = key => {
    const labels = {
      zip: "Zip",
      distance: "Distance",
      available: "Available",
      dealer: "Dealer",
      Price: "Price",
      exteriorColor: "Exterior Color",
      interiorColor: "Interior Color",
      modelNumber: "Model",
    }
    return labels[key] || key
  }

  return (
    <div css={[tw`flex flex-wrap items-center gap-2`]}>
      {Object.entries(filters).map(([key, value]) => {
        if (!value) return null
        return (
          <>
            <FilterTag
              key={key}
              label={getFilterLabel(key)}
              value={formatFilterValue(key, value)}
              filterKey={key}
              onRemove={onRemove}
            />
          </>
        )
      })}
    </div>
  )
}

export default FilterTags
